// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PShrinkOutlinedSvg from "@fishx/icons-svg/es/asn/PShrinkOutlined";
import FishxIcon from '../components/FishxIcon';

var PShrinkOutlined = function PShrinkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PShrinkOutlinedSvg
  }));
};

PShrinkOutlined.displayName = 'PShrinkOutlined';
export default React.forwardRef(PShrinkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PShrinkOutlined.js
// module id = 3629
// module chunks = 0